import { createTheme } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";

export const CustomToolbar = (
  columnsButton: boolean,
  filterButton: boolean,
  exportButton: boolean
) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        margin: "8px",
      }}
    >
      <GridToolbarContainer>
        {columnsButton && (
          <GridToolbarColumnsButton
            slotProps={{
              button: {
                variant: "contained",
                style: { textTransform: "none" },
              },
            }}
          />
        )}
        {filterButton && (
          <GridToolbarFilterButton
            slotProps={{
              button: {
                variant: "contained",
                style: { textTransform: "none" },
              },
            }}
          />
        )}
        {exportButton && (
          <GridToolbarExport
            slotProps={{
              button: {
                variant: "contained",
                style: { textTransform: "none" },
              },
            }}
            printOptions={{ disableToolbarButton: true }}
          />
        )}
      </GridToolbarContainer>
    </div>
  );
};

export const theme = createTheme({
  typography: {
    fontFamily: "karla, sans-serif",
    fontSize: 14,
  },
});
